import { render, staticRenderFns } from "./AIPanel.vue?vue&type=template&id=0d97a810&scoped=true"
import script from "./AIPanel.vue?vue&type=script&lang=js"
export * from "./AIPanel.vue?vue&type=script&lang=js"
import style0 from "./AIPanel.vue?vue&type=style&index=0&id=0d97a810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d97a810",
  null
  
)

export default component.exports